import { render } from "./ContactThanks.vue?vue&type=template&id=ca4a17ba&scoped=true"
import script from "./ContactThanks.vue?vue&type=script&lang=js"
export * from "./ContactThanks.vue?vue&type=script&lang=js"

import "./ContactThanks.vue?vue&type=style&index=0&id=ca4a17ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4a17ba"]])

export default __exports__